(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[743],{

/***/ 58165:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/web/grow-network",
      function () {
        return __webpack_require__(21300);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 10384:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ generic_title_description_with_paras_GenericTitleDescriptionWithParas; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/isomorphic-dompurify/browser.js
var browser = __webpack_require__(14304);
// EXTERNAL MODULE: ../core-ui/dist/components/Typography/index.js
var Typography = __webpack_require__(71960);
// EXTERNAL MODULE: ../core-ui/dist/constants/colors.js
var colors = __webpack_require__(94897);
;// CONCATENATED MODULE: ./components/generic-title-description-with-paras/intro-paras/ParagraphWrapper.tsx
// hooks




var ParagraphWrapper = function(param) {
    var paragraphs = param.paragraphs;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: {
            marginTop: "1rem"
        },
        children: paragraphs.map(function(para) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                as: "p",
                size: "sm",
                mSize: "s",
                color: colors/* default.GREY_700 */.Z.GREY_700,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    dangerouslySetInnerHTML: {
                        __html: (0,browser.sanitize)(para.content)
                    }
                }, para.id)
            });
        })
    });
};
/* harmony default export */ var intro_paras_ParagraphWrapper = (ParagraphWrapper);

// EXTERNAL MODULE: ./components/generic-title-description-with-paras/title-description-item/TitleDescriptionItem.module.scss
var TitleDescriptionItem_module = __webpack_require__(34791);
var TitleDescriptionItem_module_default = /*#__PURE__*/__webpack_require__.n(TitleDescriptionItem_module);
;// CONCATENATED MODULE: ./components/generic-title-description-with-paras/title-description-item/TitleDescriptionItem.tsx
// types


// styles



var TitleDescriptionItem = function(param) {
    var item = param.item;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (TitleDescriptionItem_module_default()).titleDescriptionItem,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                as: "h3",
                size: "s",
                mSize: "xs",
                color: colors/* default.GREY_700 */.Z.GREY_700,
                children: item.title ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        item.title,
                        " \xa0"
                    ]
                }) : "•"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                as: "span",
                size: "s",
                mSize: "xs",
                color: colors/* default.GREY_700 */.Z.GREY_700,
                lineHeight: "1.5rem",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    dangerouslySetInnerHTML: {
                        __html: (0,browser.sanitize)(item.description)
                    }
                })
            })
        ]
    });
};
/* harmony default export */ var title_description_item_TitleDescriptionItem = (TitleDescriptionItem);

;// CONCATENATED MODULE: ./components/generic-title-description-with-paras/title-description-item-list/TitleDescriptionItemList.tsx
// constants


var TitleDescriptionItemList = function(param) {
    var _items = param.items, items = _items === void 0 ? [] : _items;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: items.map(function(item) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(title_description_item_TitleDescriptionItem, {
                item: item
            }, item.id);
        })
    });
};
/* harmony default export */ var title_description_item_list_TitleDescriptionItemList = (TitleDescriptionItemList);

;// CONCATENATED MODULE: ./components/generic-title-description-with-paras/GenericTitleDescriptionWithParas.tsx
// components




var GenericTitleDescriptionWithParas = function(param) {
    var paragraphList = param.paragraphList, titleDescriptionList = param.titleDescriptionList, heading = param.heading;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                as: "h2",
                size: "m",
                mSize: "sm",
                children: heading
            }),
            paragraphList ? /*#__PURE__*/ (0,jsx_runtime.jsx)(intro_paras_ParagraphWrapper, {
                paragraphs: paragraphList
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(title_description_item_list_TitleDescriptionItemList, {
                items: titleDescriptionList
            })
        ]
    });
};
/* harmony default export */ var generic_title_description_with_paras_GenericTitleDescriptionWithParas = (GenericTitleDescriptionWithParas);


/***/ }),

/***/ 26801:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ getGrowNetworkPageLayout; }
/* harmony export */ });
/* unused harmony export getGrowNetworkStaticProps */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98788);
/* harmony import */ var _vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _vahak_core_dist_services_faq_service__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99891);
/* harmony import */ var components_layout_layout_methods__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62307);




var getGrowNetworkPageLayout = components_layout_layout_methods__WEBPACK_IMPORTED_MODULE_2__/* .useDefaultTopLayout */ .E;
var getGrowNetworkStaticProps = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var faqs;
        return _vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return _vahak_core_dist_services_faq_service__WEBPACK_IMPORTED_MODULE_1__/* .FaqService.getFaqsByCateg */ .P.getFaqsByCateg({
                        categSlug: "grow-networks"
                    });
                case 2:
                    faqs = _ctx.sent.faqs;
                    return _ctx.abrupt("return", {
                        faqs: faqs
                    });
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getGrowNetworkStaticProps() {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 14838:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _GrowNetwork_module_scss__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(83922);
/* harmony import */ var _GrowNetwork_module_scss__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(_GrowNetwork_module_scss__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var _service_data_ServiceData__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65962);
/* harmony import */ var _vahak_core_dist_services_user_analytics_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8880);
/* harmony import */ var _vahak_core_dist_components_app_anchor_A__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70561);
/* harmony import */ var _vahak_core_dist_components_app_btn_AppBtn__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(49995);
/* harmony import */ var _common_features_Features__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(91299);
/* harmony import */ var _common_achievements_Achievements__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(16609);
/* harmony import */ var _common_hero_section_HeroSection__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(46523);
/* harmony import */ var _common_how_it_works_HowItWorks__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(42326);
/* harmony import */ var _common_faq_Faq__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(71729);
/* harmony import */ var components_utils_AppImg__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(17073);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(42386);
/* harmony import */ var _vahak_core_dist_icons_arrow_right_white_svg__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(89905);
/* harmony import */ var _vahak_core_dist_constants_event_names__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(69406);
/* harmony import */ var _vahak_core_dist_constants_misc__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(77370);
/* harmony import */ var _vahak_core_dist_constants_Pages__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(52489);
/* harmony import */ var _common_page_meta_tags_PageMetaTags__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(96696);
/* harmony import */ var _constants_breadcrumbs_constants__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(96080);
/* harmony import */ var _common_service_information_ServiceInformation__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(35778);
/* harmony import */ var _generic_title_description_with_paras_GenericTitleDescriptionWithParas__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(10384);
/* harmony import */ var _vahak_core_ui_dist_layout_Flex__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(31013);























var metaData = {
    title: "Grow Your Transport Business on India's #1 Transport Community | Vahak",
    description: "Grow your Transport Business by establishing trustworthy connections with India's Top transporters through our #1 digital transportation network. Join now!",
    keywords: " transport business,how to start a transport business,transport business ideas, how to start a transport business in india, transport business plan,truck transport business in india, how to grow transport business, goods transport business,best transport business in india, how to run transport business,how to expand logistics business, how to expand transport business, how to grow transport business in india, how to make a transport business successful,online transport business,online transport business in india,",
    canonicalUrl: "https://www.vahak.in/grow-network",
    schemaOrgJsonUrl: "/grow-network",
    ogImgSrc: "https://d3ib4ot6oar1ep.cloudfront.net/1080/75/webp/largest-transporter-network-india_desktop.png",
    ogImgAltText: "Transport Business",
    breadcrumbList: (0,_constants_breadcrumbs_constants__WEBPACK_IMPORTED_MODULE_21__/* .breadcrumbsConstants */ .U)({}).growNetwork
};
var GrowNetwork = function(param) {
    var faqs = param.faqs;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_12__/* .useTranslation */ .$G)("servicePages").t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_common_page_meta_tags_PageMetaTags__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                title: metaData.title,
                description: metaData.description,
                keywords: metaData.keywords,
                canonicalUrl: metaData.canonicalUrl,
                ogUrl: metaData.canonicalUrl,
                ogImgSrc: metaData.ogImgSrc,
                ogImgAltText: metaData.ogImgAltText,
                schemaOrgJsonUrl: metaData.schemaOrgJsonUrl,
                breadcrumbList: metaData.breadcrumbList
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("main", {
                className: (_GrowNetwork_module_scss__WEBPACK_IMPORTED_MODULE_22___default().main),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_common_hero_section_HeroSection__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        bannerTitle: t("servicePages:grow-network.hero-section.bannerTitle"),
                        bannerText: t("servicePages:grow-network.hero-section.bannerText"),
                        hrefLabel: t("servicePages:grow-network.hero-section.hrefLabel"),
                        hrefURL: "https://6r7cz.app.link/startnetworking/?".concat(_vahak_core_dist_constants_misc__WEBPACK_IMPORTED_MODULE_15__/* .SOURCE_UTM */ .vq, "=").concat(_vahak_core_dist_constants_Pages__WEBPACK_IMPORTED_MODULE_16__/* .PageTypes.GROW_NETWORK */ .c.GROW_NETWORK),
                        onLinkClick: function() {
                            (0,_vahak_core_dist_services_user_analytics_service__WEBPACK_IMPORTED_MODULE_3__/* .ga4sendEvent */ .zs)(_vahak_core_dist_constants_event_names__WEBPACK_IMPORTED_MODULE_14__/* .GA4EventNames.Servicepage_grow_network */ .wQ.Servicepage_grow_network, {
                                value: _vahak_core_dist_constants_event_names__WEBPACK_IMPORTED_MODULE_14__/* .GA4ServicePageGrowNetworkEventValues.start_networking */ .GM.start_networking
                            });
                        },
                        // srcSetURL={`${IMG_BASE_URL}/largest-transporter-network-india_desktop_3x.png 1518w, ${IMG_BASE_URL}/largest-transporter-network-india_desktop_2x.png 1012w, ${IMG_BASE_URL}/largest-transporter-network-india_desktop.png 506w, ${IMG_BASE_URL}/largest-transporter-network-india_mobile_3x.png 810w, ${IMG_BASE_URL}/largest-transporter-network-india_mobile_2x.png 540w, ${IMG_BASE_URL}/largest-transporter-network-india_mobile.png 270w`}
                        srcURL: "largest-transporter-network-india_desktop.png",
                        altText: "truck with boxes and India map"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_common_achievements_Achievements__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        achievementData: (0,_service_data_ServiceData__WEBPACK_IMPORTED_MODULE_2__/* .useGnAchievement */ .H5)(),
                        sectionTitle: t("servicePages:grow-network.achievements.sectionTitle"),
                        sectionText: t("servicePages:grow-network.achievements.sectionText")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_common_service_information_ServiceInformation__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                        heading: t("servicePages:grow-network.how-to-start-a-transport-business.heading"),
                        sectionTitle: "",
                        sectionText: t("servicePages:grow-network.how-to-start-a-transport-business.description"),
                        descriptionComponent: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_ui_dist_layout_Flex__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .ZP, {
                            gap: 30,
                            flexDirection: "column",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_generic_title_description_with_paras_GenericTitleDescriptionWithParas__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                titleDescriptionList: (0,_service_data_ServiceData__WEBPACK_IMPORTED_MODULE_2__/* .useStepsHowToStartBusiness */ .ME)(),
                                heading: ""
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_common_service_information_ServiceInformation__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                        heading: t("servicePages:grow-network.how-to-make-a-transport-business-successful.heading"),
                        sectionTitle: "",
                        sectionText: t("servicePages:grow-network.how-to-make-a-transport-business-successful.description"),
                        descriptionComponent: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_ui_dist_layout_Flex__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .ZP, {
                            gap: 30,
                            flexDirection: "column",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_generic_title_description_with_paras_GenericTitleDescriptionWithParas__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                titleDescriptionList: (0,_service_data_ServiceData__WEBPACK_IMPORTED_MODULE_2__/* .useStepsHowToMakeBusinessSuccessful */ .AV)(),
                                heading: ""
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_common_service_information_ServiceInformation__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                        heading: t("servicePages:grow-network.grow-your-transport-business-with-vahak.heading"),
                        sectionTitle: "",
                        sectionText: t("servicePages:grow-network.grow-your-transport-business-with-vahak.description")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_common_features_Features__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        features: (0,_service_data_ServiceData__WEBPACK_IMPORTED_MODULE_2__/* .useGrowFeatures */ .Bx)(),
                        sectionTitle: t("servicePages:grow-network.features.sectionTitle"),
                        sectionText: t("servicePages:grow-network.features.sectionText"),
                        ctaLink: "https://6r7cz.app.link/growwithvahak",
                        ctaLabel: t("servicePages:grow-network.features.ctaLabel"),
                        ctaClass: (_GrowNetwork_module_scss__WEBPACK_IMPORTED_MODULE_22___default().ctaBg),
                        onCtaClick: function() {
                            (0,_vahak_core_dist_services_user_analytics_service__WEBPACK_IMPORTED_MODULE_3__/* .ga4sendEvent */ .zs)(_vahak_core_dist_constants_event_names__WEBPACK_IMPORTED_MODULE_14__/* .GA4EventNames.Servicepage_grow_network */ .wQ.Servicepage_grow_network, {
                                value: _vahak_core_dist_constants_event_names__WEBPACK_IMPORTED_MODULE_14__/* .GA4ServicePageGrowNetworkEventValues.grow_network */ .GM.grow_network
                            });
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_common_how_it_works_HowItWorks__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        howitwork: (0,_service_data_ServiceData__WEBPACK_IMPORTED_MODULE_2__/* .useGrowHowItworkData */ .yu)(),
                        sectionTitle: t("servicePages:grow-network.HowItWorks.sectionTitle"),
                        sectionText: t("servicePages:grow-network.HowItWorks.sectionText"),
                        tabAppNav: t("servicePages:online-load-booking.HowItWorks.tabAppNav"),
                        tabWebNav: t("servicePages:online-load-booking.HowItWorks.tabWebNav"),
                        onAppTabChange: function() {
                            (0,_vahak_core_dist_services_user_analytics_service__WEBPACK_IMPORTED_MODULE_3__/* .ga4sendEvent */ .zs)(_vahak_core_dist_constants_event_names__WEBPACK_IMPORTED_MODULE_14__/* .GA4EventNames.Servicepage_grow_network */ .wQ.Servicepage_grow_network, {
                                value: _vahak_core_dist_constants_event_names__WEBPACK_IMPORTED_MODULE_14__/* .GA4ServicePageGrowNetworkEventValues.mobile_app */ .GM.mobile_app
                            });
                        },
                        onWebTabChange: function() {
                            (0,_vahak_core_dist_services_user_analytics_service__WEBPACK_IMPORTED_MODULE_3__/* .ga4sendEvent */ .zs)(_vahak_core_dist_constants_event_names__WEBPACK_IMPORTED_MODULE_14__/* .GA4EventNames.Servicepage_grow_network */ .wQ.Servicepage_grow_network, {
                                value: _vahak_core_dist_constants_event_names__WEBPACK_IMPORTED_MODULE_14__/* .GA4ServicePageGrowNetworkEventValues.web */ .GM.web
                            });
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_common_faq_Faq__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                        faqs: faqs,
                        sectionTitle: t("servicePages:online-load-booking.Faq.sectionTitle"),
                        sectionText: t("servicePages:online-load-booking.Faq.sectionText")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                        className: (_GrowNetwork_module_scss__WEBPACK_IMPORTED_MODULE_22___default().ctaBanner),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_dist_components_app_anchor_A__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            href: "https://6r7cz.app.link/growbusiness",
                            openInNewTab: true,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "container",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_GrowNetwork_module_scss__WEBPACK_IMPORTED_MODULE_22___default().ctarow),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: (_GrowNetwork_module_scss__WEBPACK_IMPORTED_MODULE_22___default().imgBox),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_utils_AppImg__WEBPACK_IMPORTED_MODULE_11__["default"], {
                                                src: "gn_ctaBannerImg.png",
                                                layout: "responsive",
                                                alt: "CTABanner",
                                                width: "310",
                                                height: "153"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: (_GrowNetwork_module_scss__WEBPACK_IMPORTED_MODULE_22___default().textBox),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                    children: t("servicePages:grow-network.section-ctaBanner.heading")
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_vahak_core_dist_components_app_btn_AppBtn__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                    className: (_GrowNetwork_module_scss__WEBPACK_IMPORTED_MODULE_22___default().ctaBtn),
                                                    children: [
                                                        t("servicePages:grow-network.section-ctaBanner.button"),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_dist_icons_arrow_right_white_svg__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {})
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (GrowNetwork);


/***/ }),

/***/ 21300:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ GrowNetworkPage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _components_service_pages_grow_network_GrowNetwork__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14838);
/* harmony import */ var _components_service_pages_constants_growNetwork_constants_methods__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26801);




var __N_SSG = true;
function GrowNetworkPage(param) {
    var faqs = param.faqs;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_service_pages_grow_network_GrowNetwork__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        faqs: faqs
    });
};
GrowNetworkPage.getLayout = _components_service_pages_constants_growNetwork_constants_methods__WEBPACK_IMPORTED_MODULE_3__/* .getGrowNetworkPageLayout */ .k;


/***/ }),

/***/ 34791:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"titleDescriptionItem":"TitleDescriptionItem_titleDescriptionItem__LU6aL"};

/***/ }),

/***/ 83922:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ctaBanner":"GrowNetwork_ctaBanner__EQRwa","ctarow":"GrowNetwork_ctarow__qdOR6","textBox":"GrowNetwork_textBox__bFHE7","ctaBtn":"GrowNetwork_ctaBtn__r0_YH","main":"GrowNetwork_main__zb_so","imgBox":"GrowNetwork_imgBox__Xfsp3","ctaBg":"GrowNetwork_ctaBg__qtRiE"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4304,6090,7783,5689,9774,2888,179], function() { return __webpack_exec__(58165); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);